import { FC } from 'react';
import classNames from 'classnames';

import { CloudinaryImage } from 'components/common/CloudinaryImage';
import { Model } from 'types';
import { formatPrice } from 'utils/text-helpers';

type RequestPricePillProps = {
  model: Model;
  isDark?: boolean;
  price: number;
};

export const RequestPricePill: FC<RequestPricePillProps> = ({ model, price, isDark = false }) => (
  <div
    className={classNames(
      'border-radius-24 p-3 d-flex align-items-center',
      isDark ? 'bg-pale8' : 'border bg-requestGreen6 border-requestGreen10'
    )}
  >
    <div>
      <CloudinaryImage
        alt={model.displayName}
        width={54}
        height={68}
        src={model.images?.[0]?.optimizedUrl || 'model_placeholder.png'}
      />
    </div>
    <div className={classNames('px-3 flex-1 text-start fs-12px', isDark ? 'text-turquoise' : 'text-success')}>
      <div>{model.brand.displayName}</div>
      <div>{model.displayName}</div>
    </div>
    <div
      className={classNames(
        'd-flex align-items-center border-radius-60 py-2 px-3 fs-14px letter-spacing-006 border ',
        isDark ? 'text-turquoise bg-pale10 border-pale16' : 'text-success bg-requestGreen10 border-requestGreen16'
      )}
    >
      {formatPrice(price)}
    </div>
  </div>
);
